import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const PracticeAreas = (props) => {
	if (_.isArray(props.data.practice_areas) && props.data.practice_areas.length) {
		return (
			<ul className="bio-list">{
				_.map(props.data.practice_areas, (data) => {
					const paPercentage = parseInt(data.pra_percentage, 10) ? `${data.pra_percentage}%` : '';
					return (
						<li className="bio-list__item" key={_.uniqueId('list-item-')}>
							{data.pra_title} {paPercentage}
						</li>
					);
				})}
			</ul>
		);
	}

	return null;
};

PracticeAreas.propTypes = {
	data: PropTypes.object.isRequired,
};

export default PracticeAreas;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/practice-areas.js